import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { buildColumns, buildOrderData } from '../../helpers/tableUtil';
import { SortDirection } from '../../models/global';
import { State } from '../../models/state';
import { getEmails } from '../../store/actions/email';
import Button from '../FormComponents/Button';
import Table from '../Table/Table';
import ToastMessage from '../ToastMessage/ToastMessage';

const tableMap = new Map<string, string>([
  ['Survey info', ''],
  ['Type', 'type'],
  ['Status', 'status'],
  ['Email creation date', 'createdAt'],
]);
const { columns, rowsUnsortable } = buildColumns(tableMap);

function Emails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const rowsPerPage = 10;
  const [page, setPage] = useState(0);
  const [toastType, setToastType] = useState<'success' | 'error'>('success');
  const [toast, setToast] = useState('');
  const [orderBy, setOrderBy] = useState('Email creation date');
  const [sortDirection, setSortDirection] = useState<SortDirection>('desc');
  const { emails, emailCount } = useSelector((state: State) => state.email);
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    const runOnce = () => {
      setToastType('success');
      setToast(location?.state?.message);
      window.history.replaceState({}, '');
    };
    if (location?.state?.message) {
      runOnce();
    }
  }, [location?.state?.message]);

  useEffect(() => {
    const orderData = buildOrderData({
      orderBy,
      sortDirection,
      tableMap,
    });

    (() => setPageLoading(true))();
    dispatch(
      getEmails({ limit: rowsPerPage, page: page + 1, orderData }, () => {
        setPageLoading(false);
      }),
    );
  }, [dispatch, orderBy, sortDirection, page]);

  const goToCreateEmail = () => {
    navigate('/emails/create');
  };

  if (pageLoading) {
    return (
      <Box className='loader'>
        <CircularProgress size={40} color='inherit' />
      </Box>
    );
  }
  return (
    <>
      <Box className='list'>
        <Box className='list-header' sx={{ mb: 2 }}>
          <Typography variant='h5'>Emails</Typography>
          <Box className='create-button'>
            <Button text='Create' onClick={goToCreateEmail} />
          </Box>
        </Box>
        <Table
          columns={columns}
          rowsUnsortable={rowsUnsortable}
          rows={emails}
          count={emailCount}
          page={page}
          rowsPerPage={rowsPerPage}
          setPage={setPage}
          rowClickHandler={(id: string) => navigate(`/emails/${id}`)}
          orderBy={orderBy}
          handleOrder={setOrderBy}
          sortDirection={sortDirection}
          handleSortDirection={setSortDirection}
        />
      </Box>
      <ToastMessage toast={toast} close={() => setToast('')} messageType={toastType} />
    </>
  );
}

export default Emails;
